import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";

export default function(notification: Notification): NotificationData | false {
  if (notification.type === NotificationType.LIVECHAT_INVITATION_CREATED) {
    emitter.emit(EVENTS.LIVECHAT_INVITATION_CREATED, notification);
  }
  if (notification.type === NotificationType.LIVECHAT_INVITATION_APPROVED) {
    emitter.emit(EVENTS.LIVECHAT_INVITATION_APPROVED, notification);
  }
  if (notification.type === NotificationType.LIVECHAT_INVITATION_DECLINED) {
    emitter.emit(EVENTS.LIVECHAT_INVITATION_DECLINED, notification);
  }
  return false;
}
